var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container full-height"},[_c('vs-row',{attrs:{"vs-align":"center","vs-type":"flex","vs-justify":"center","vs-w":"12"}},[_c('vs-col',{attrs:{"vs-type":"flex","vs-justify":"center","vs-align":"center","vs-xs":"12","vs-sm":"10","vs-lg":"8"}},[(_vm.showRestorePasswordForm)?_c('RestorePasswordForm'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }